angular.module('bmsApp.settings').controller('SalesTypeCtrl',
	function ($scope, $log, SalesTypeSvc, NominalCodeSvc, notify, $q) {

		$scope.processing = false;

		$scope.salesTypes = [];
		var promises = [];
		promises.push(SalesTypeSvc.index());
		promises.push(NominalCodeSvc.index());


		$q.all(promises)
			.then(function (responses) {
				$scope.salesTypes = responses[0].data.sales_type_collection;
				$scope.nominalCodes = responses[1].data.nominal_code_collection;
			});

		$scope.setEditable = function (setting) {
			setting.editing = true;

		};
		$scope.cancelEditing = function (setting) {
			setting.editing = false;
		};

		$scope.save = function (setting) {
			setting.editing = false;
		};

		$scope.delete = function (setting, index) {
			if (setting.newlyAdded) {
				$scope.salesTypes.splice(index, 1);
			}
			else {
				setting.deleted = true;
			}
		};

		$scope.reinstate = function (setting) {
			setting.deleted = false;
		};

		$scope.addNew = function () {
			var obj = {id: '', nominal_code: {}, deleted: false};
			$scope.salesTypes.push(obj);
			obj.editing = true;
			obj.newlyAdded = true;
		};

		$scope.submit = function (data) {
			$scope.processing = true;
			SalesTypeSvc.update(data)
				.then(function (response) {
					notify({
						message: 'List saved'
					});
				}, function (error) {
					$scope.errors = error;
				})
				.finally(function () {
					$scope.processing = false;
				});

		};

	});



